import { put, takeLatest, call } from 'redux-saga/effects'

import * as ActionTypes from '../../constants/ActionTypes'
import { fetchShowtimes } from '../../services/fetchShowtimes'
import { preloadImages } from '../../services/preloadImages'
import { dataSuccess } from '../../actions/data'

function* dataFetch() {
  const data = yield call(fetchShowtimes)
  yield put(dataSuccess(data))
  // Warm the browser cache for all remote movie posters/stills in the
  // background so hovering/opening a screening shows them instantly. Fire and
  // forget - the preloader schedules itself on idle and never throws.
  preloadImages(data)
}

export default function* watchDataFetch() {
  yield takeLatest(ActionTypes.DATA_FETCH, dataFetch)
}
